import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P5-E1",
    audio: "img/FriendsPlus/Page4/Audio/audio-e3-p4.mp3",
    video: "Videos/E3.p4.mp4",
    component: UI,
    recorder:true,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page5/E1/1.jpg" }],
      [
        // Column2
        { url: 'img/FriendsPlus/Page4/E3/4.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh1-e3-p4.mp3' },
        { url: 'img/FriendsPlus/Page4/E3/5.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh2-e3-p4.mp3' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page4/E3/6.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh3-e3-p4.mp3' },
        { url: 'img/FriendsPlus/Page4/E3/7.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh4-e3-p4.mp3' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page4/E3/8.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh5-e3-p4.mp3' },
        { url: 'img/FriendsPlus/Page4/E3/9.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh6-e3-p4.mp3' },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P5-E2",
    audio: "",
    video: "",
    component: DesignUnderLine,
    totalInput: 5,
    exerciseKey: "img/FriendsPlus/Page5/E2/Key/answerKey.png",
    questionImage: [
      // Row
      [{ url: "img/FriendsPlus/Page5/E2/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page5/E2/2.jpg" },
        { url: "img/FriendsPlus/Page5/E2/3.jpg", input: 1 },
        { url: "img/FriendsPlus/Page5/E2/4.jpg" },
        { url: "img/FriendsPlus/Page5/E2/5.jpg", input: 1, isCorrect: true },
        { url: "img/FriendsPlus/Page5/E2/6.jpg" },
      ],
      [
        // Column3
        { url: "img/FriendsPlus/Page5/E2/7.jpg" },
        { url: "img/FriendsPlus/Page5/E2/8.jpg", input: 2 },
        { url: "img/FriendsPlus/Page5/E2/9.jpg" },
        { url: "img/FriendsPlus/Page5/E2/10.jpg", input: 2, isCorrect: true },
        { url: "img/FriendsPlus/Page5/E2/11.jpg" },
        { url: "img/FriendsPlus/Page5/E2/12.jpg", input: 3, isCorrect: true },
        { url: "img/FriendsPlus/Page5/E2/13.jpg" },
        { url: "img/FriendsPlus/Page5/E2/14.jpg", input: 3 },
        { url: "img/FriendsPlus/Page5/E2/15.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page5/E2/16.jpg" },
        { url: "img/FriendsPlus/Page5/E2/17.jpg", input: 4 },
        { url: "img/FriendsPlus/Page5/E2/18.jpg" },
        { url: "img/FriendsPlus/Page5/E2/19.jpg", input: 4, isCorrect: true },
        { url: "img/FriendsPlus/Page5/E2/20.jpg" },
        { url: "img/FriendsPlus/Page5/E2/21.jpg", input: 5 },
        { url: "img/FriendsPlus/Page5/E2/22.jpg" },
        { url: "img/FriendsPlus/Page5/E2/23.jpg", input: 5, isCorrect: true },
        { url: "img/FriendsPlus/Page5/E2/24.jpg" },
      ],
    ],
  },
  3: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P5-E3",
    audio: "img/FriendsPlus/Page5/Audio/audio-e3-p5.mp3",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page5/E3/Key/answerKey.png",
    stylesTextInput: { borderBottomWidth: 0, backgroundColor: 'transparent' },
    inputSize: 34,
    maxLength: 1,
    titleImage: "",
    titleQuestion: [
      {
        color: "#44509f",
        num: "3",
        title:
          'Listen and number. <headphone name="03" src="img/FriendsPlus/Page5/Audio/tieude-e3-p5.mp3"></headphone>',
      },
    ],
    questionImage: [],
    questions: [
      {
        title: `
          <div style='display: flex; flex-direction: row;position: relative;'>
            <img src="img/FriendsPlus/Page5/E3/title.jpg" style="width: 100%">
            <div style='position: absolute;top: 330px;left: 189px;'>#</div>
            <div style='position: absolute;top: 447px;left: 254px;'>#</div>
            <div style='position: absolute;top: 522px;left: 369px;'>#</div>
            <div style='position: absolute;top: 297px;left: 420px;'>#</div>
            <div style='position: absolute;top: 296px;left: 507px;'>#</div>
            <div style='position: absolute;top: 369px;left: 595px;'>#</div>
            <div style='position: absolute;top: 450px;left: 649px;'>#</div>
            <div style='position: absolute;top: 356px;left: 750px;'>#</div>
          </div>
        `,
        answer: [ '2', '4', '3', '6', '5', '7', '9', '8'],
      },
    ],
  },
  4: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P5-E4",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page5/E4/1.jpg" }]],
  },
};

export default json;
